import styled, { css } from 'styled-components';
import { Tag, Button } from 'antd';

export const StyledTag = styled(Tag)`
  ${({ theme }) => theme.noodera.fontTypes.font5};
  color: ${({ theme }) => theme.palette.greyscale.black};
  background-color: ${({ color, theme }) => color || theme.palette.greyscale.concrete};
  border-radius: 10px;
`;

const buttonStyles = css`
  border-radius: 10px;
  ${({ theme }) => theme.noodera.fontTypes.font5};
`;

export const StyledPrimaryButton = styled(Button)`
  ${buttonStyles}
  color: ${({ theme }) => theme.palette.greyscale.white};
  background-color: ${({ theme }) => theme.palette.noodle.primary};
`;

export const StyledInvertedButton = styled(Button)`
  ${buttonStyles}
  color: ${({ theme }) => theme.palette.noodle.primary};
  border: 1px solid ${({ theme }) => theme.palette.noodle.primary};
`;
